/**
 * /admin/system — settings, integrations, system health, email templates,
 * pricing import (iter114s.76).
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { AdminLayout } from './AdminLayout';
import { IntegrationSecretsPanel } from './IntegrationSecretsPanel';
import { IntegrationHealthChecks } from './IntegrationHealthChecks';
import MaintenancePanel from './MaintenancePanel';
import SystemHealthWidget from './SystemHealthWidget';
import { EnvHealthBanner } from './EnvHealthBanner';
import { EmailTemplateEditor } from './EmailTemplateEditor';

const AdminSystem = () => (
  <AdminLayout>
    <div className="max-w-screen-2xl space-y-6">
      <header>
        <h1 className="text-2xl font-bold text-[#14281D]" data-testid="admin-system-heading">System</h1>
        <p className="text-sm text-[#1F3D2C]/70">Integrations, secrets, automation logs, system health, email templates, pricing imports.</p>
      </header>
      <EnvHealthBanner />
      <SystemHealthWidget />
      <EmailTemplateEditor />
      <IntegrationHealthChecks />
      <IntegrationSecretsPanel />
      <MaintenancePanel />
      <div className="bg-white rounded-lg shadow-sm border border-[#E5E7EB] p-4">
        <h2 className="text-sm font-bold text-[#14281D] mb-2">Other utilities</h2>
        <Link
          to="/admin/pricing-import"
          className="text-sm font-semibold text-[#2F5D3A] hover:text-[#6FBF73] hover:underline"
          data-testid="admin-system-pricing-import-link"
        >
          → Pricing CSV import
        </Link>
      </div>
    </div>
  </AdminLayout>
);

export default AdminSystem;
